module.exports = "<div ng-show=\"display\" class=\"loading-template\">\n    <img src=\"/qnb/styles/images/common/ajax-loader2.gif\" />\n</div>"


//////////////////
// WEBPACK FOOTER
// ../common/grunt/webpack/loaders/text-loader!../common/js/src/edge/platform/basler/templates/basler-loading-template.html
// module id = 566
// module chunks = 0